const ls_ttl = require('localstorage-ttl');

const tracky = require('src/frontend/helper/general/m_trackEvent');
const {
  getConsentActions,
  storeConsentAction,
  clearConsentActions,
} = require('src/frontend/helper/consent/consentLogFallback');
const { setC3S } = require('app/common/helpers/c3s_cookie');

const ttl_ms = 1000 * 60 * 60 * 24 * 30 * 6; // Six months

const topBannerClosedStorageKey = 'ls-cookies-gdpr-ack';
const HAD_NO_C3S_KEY = 'ls-gdpr-had-no-c3s';
const bodyClass = 'gdpr-cb-shown';
const hasC3S = document.cookie.match(/c3s=\d+-\d+-[0-3]/);
let defaultC3S = 3;

const callConsentService = function(
  action,
  origin,
  fallbackData,
  defaultConsentClass = 3
) {
  if (origin == null) {
    origin = '';
  }
  if (fallbackData == null) {
    fallbackData = {};
  }
  const matchC3s = document.cookie.match(/c3s=\d+-\d+-([0-3])/);
  const consentClass = matchC3s ? matchC3s[1] : defaultConsentClass;

  const url = `${origin}/layout/calls/consent-service/${action}/v1?c3s=${consentClass}`;
  return fetch(url, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'x-ls-consent-fallback': JSON.stringify(fallbackData),
    },
  })
    .then(res => {
      if (!res.ok) {
        throw `failed so set consent due to api status: ${res.status}`;
      }
      return res.json();
    })
    .then(json => {
      let err;
      if ((err = json != null ? json.err : undefined)) {
        if (action !== 'fallback') {
          return storeConsentAction(action, consentClass, err.termsVersion);
        }
      }
      return clearConsentActions();
    })
    .catch(e => {
      tracky(e.event, e.error);
    });
};

const checkGdprConsentFallback = function() {
  const consentActions = getConsentActions();
  if (consentActions && Object.keys(consentActions).length) {
    return callConsentService('fallback', '', consentActions);
  }
  return '';
};

const initBottomBanner = function() {
  const bottomBanner = document.getElementById('gdpr-bottom-banner');
  if (!bottomBanner || I18n.country !== 'NL') return '';
  defaultC3S = 0;

  if (!hasC3S) {
    //  If no c3s cookie exists, then create it now with consentClass 0, before the tag manager
    //  loads.  Set the firstTimeUser local storage key, so that the bottomBanner is shown.
    setC3S(defaultC3S, 1);
    try {
      ls_ttl.set(HAD_NO_C3S_KEY, true, ttl_ms);
    } catch (e) {}
  } else {
    localStorage.removeItem(HAD_NO_C3S_KEY);
  }
  return '';
};

const initTopBanner = function(origin) {
  if (origin == null) {
    origin = '';
  }

  const topBanner = document.getElementById('ls-gdpr-cookie-banner');
  if (!topBanner) {
    return;
  }

  if (!hasC3S) {
    //  If no c3s cookie exists, then call consent service to create it,
    //  delete the local storage key, and continue to show the banner.
    callConsentService('notice', origin, {}, defaultC3S);
    localStorage.removeItem(topBannerClosedStorageKey);
  } else {
    try {
      if (ls_ttl.get(topBannerClosedStorageKey)) {
        //  If the user has already consented to our use of cookies,
        //  then we do not need to present the banner.
        return;
      }
    } catch (error) {}
  }

  const closeTopBanner = function() {
    topBanner.parentNode.removeChild(topBanner);
    document.body.classList.remove(bodyClass);
    callConsentService('notice_all', origin);
    try {
      ls_ttl.set(topBannerClosedStorageKey, true, ttl_ms);
    } catch (error1) {}
  };

  topBanner.classList.remove('ls-hide');
  document.body.classList.add(bodyClass);
  const closeTopBannerBtn = document.getElementById('ls-accept-cookies');
  closeTopBannerBtn.addEventListener('click', closeTopBanner, { once: true });
};

exports.initGdprCookieBanners = function(origin = '') {
  checkGdprConsentFallback();
  initBottomBanner();
  initTopBanner(origin);
};

exports.callConsentService = callConsentService;
